export const supportFormCardCss = {
  gap: "0.625rem",
};

export const supportFormFieldCss = {
  width: "100%",
  padding: 0,
  input: { height: "46px" },
  textarea: { minHeight: "140px", resize: "vertical" as const },
};

export const supportFormSidebarCss = (isMobile: boolean) => ({
  display: "flex",
  flexDirection: "column" as const,
  width: "100%",
  flex: isMobile ? undefined : "0 0 19rem",
  minWidth: isMobile ? undefined : "19rem",
  alignSelf: "stretch" as const,
});

export const supportFormAttachmentsSectionCss = {
  display: "flex",
  flexDirection: "column" as const,
  gap: "0.625rem",
  height: "100%",
};
